import angular from 'angular';

import {} from './od-buyer-listing-info.less';

module.exports = angular.module('market.component.od-buyer-listing-info', [
])
.component('odBuyerListingInfo', {
  bindings: {
    listing: '<',
  },
  template: require('./od-buyer-listing-info.jade')(),
})
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-buyer-listing-info.js
 **/